import AbstractFilter from './abstract-filter'

const moduleCategories = new AbstractFilter()

moduleCategories.configuration.api.read = 'news-categories'

export default {
  namespaced: true,
  state: moduleCategories.state,
  mutations: moduleCategories.mutations,
  actions: moduleCategories.actions
}
